"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetSectorLocationSectorsSectorLocationGetRequest$ = exports.GetSectorLocationSectorsSectorLocationGetRequest$outboundSchema = exports.GetSectorLocationSectorsSectorLocationGetRequest$inboundSchema = exports.GetSectorLocationSectorsSectorLocationGetSecurity$ = exports.GetSectorLocationSectorsSectorLocationGetSecurity$outboundSchema = exports.GetSectorLocationSectorsSectorLocationGetSecurity$inboundSchema = void 0;
exports.getSectorLocationSectorsSectorLocationGetSecurityToJSON = getSectorLocationSectorsSectorLocationGetSecurityToJSON;
exports.getSectorLocationSectorsSectorLocationGetSecurityFromJSON = getSectorLocationSectorsSectorLocationGetSecurityFromJSON;
exports.getSectorLocationSectorsSectorLocationGetRequestToJSON = getSectorLocationSectorsSectorLocationGetRequestToJSON;
exports.getSectorLocationSectorsSectorLocationGetRequestFromJSON = getSectorLocationSectorsSectorLocationGetRequestFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
/** @internal */
exports.GetSectorLocationSectorsSectorLocationGetSecurity$inboundSchema = z.object({
    Bearer: z.string().optional(),
    "X-API-KEY": z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "Bearer": "bearer",
        "X-API-KEY": "xApiKey",
    });
});
/** @internal */
exports.GetSectorLocationSectorsSectorLocationGetSecurity$outboundSchema = z.object({
    bearer: z.string().optional(),
    xApiKey: z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        bearer: "Bearer",
        xApiKey: "X-API-KEY",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var GetSectorLocationSectorsSectorLocationGetSecurity$;
(function (GetSectorLocationSectorsSectorLocationGetSecurity$) {
    /** @deprecated use `GetSectorLocationSectorsSectorLocationGetSecurity$inboundSchema` instead. */
    GetSectorLocationSectorsSectorLocationGetSecurity$.inboundSchema = exports.GetSectorLocationSectorsSectorLocationGetSecurity$inboundSchema;
    /** @deprecated use `GetSectorLocationSectorsSectorLocationGetSecurity$outboundSchema` instead. */
    GetSectorLocationSectorsSectorLocationGetSecurity$.outboundSchema = exports.GetSectorLocationSectorsSectorLocationGetSecurity$outboundSchema;
})(GetSectorLocationSectorsSectorLocationGetSecurity$ || (exports.GetSectorLocationSectorsSectorLocationGetSecurity$ = GetSectorLocationSectorsSectorLocationGetSecurity$ = {}));
function getSectorLocationSectorsSectorLocationGetSecurityToJSON(getSectorLocationSectorsSectorLocationGetSecurity) {
    return JSON.stringify(exports.GetSectorLocationSectorsSectorLocationGetSecurity$outboundSchema.parse(getSectorLocationSectorsSectorLocationGetSecurity));
}
function getSectorLocationSectorsSectorLocationGetSecurityFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.GetSectorLocationSectorsSectorLocationGetSecurity$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'GetSectorLocationSectorsSectorLocationGetSecurity' from JSON`);
}
/** @internal */
exports.GetSectorLocationSectorsSectorLocationGetRequest$inboundSchema = z.object({
    sector: z.string(),
});
/** @internal */
exports.GetSectorLocationSectorsSectorLocationGetRequest$outboundSchema = z.object({
    sector: z.string(),
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var GetSectorLocationSectorsSectorLocationGetRequest$;
(function (GetSectorLocationSectorsSectorLocationGetRequest$) {
    /** @deprecated use `GetSectorLocationSectorsSectorLocationGetRequest$inboundSchema` instead. */
    GetSectorLocationSectorsSectorLocationGetRequest$.inboundSchema = exports.GetSectorLocationSectorsSectorLocationGetRequest$inboundSchema;
    /** @deprecated use `GetSectorLocationSectorsSectorLocationGetRequest$outboundSchema` instead. */
    GetSectorLocationSectorsSectorLocationGetRequest$.outboundSchema = exports.GetSectorLocationSectorsSectorLocationGetRequest$outboundSchema;
})(GetSectorLocationSectorsSectorLocationGetRequest$ || (exports.GetSectorLocationSectorsSectorLocationGetRequest$ = GetSectorLocationSectorsSectorLocationGetRequest$ = {}));
function getSectorLocationSectorsSectorLocationGetRequestToJSON(getSectorLocationSectorsSectorLocationGetRequest) {
    return JSON.stringify(exports.GetSectorLocationSectorsSectorLocationGetRequest$outboundSchema.parse(getSectorLocationSectorsSectorLocationGetRequest));
}
function getSectorLocationSectorsSectorLocationGetRequestFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.GetSectorLocationSectorsSectorLocationGetRequest$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'GetSectorLocationSectorsSectorLocationGetRequest' from JSON`);
}
//# sourceMappingURL=getsectorlocationsectorssectorlocationget.js.map